import {SvgIcon, SvgIconProps} from '@mui/material';
import React from 'react';
// @ts-ignore
import {ReactComponent as arrow_bottom_left} from '../../../assets/arrows/cropsSoils/arrow_bottom_left.svg';

const ArrowBottomLeft: React.FC<SvgIconProps> = (props) => {
  return (
    <SvgIcon {...props} component={arrow_bottom_left} viewBox='0 0 107 114' />
  );
};

export default ArrowBottomLeft;
